import React from "react";

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

const IconTalk: React.FC<Props> = ({
  size = 32,
  color = "#3E3851",
  className = "fill-neutral-60 flex",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M13.793 12.7327C13.7383 12.8181 13.6475 12.8666 13.5206 12.8782C13.3936 12.8897 13.2797 12.8451 13.1788 12.7442L11.8443 11.4095H5.33147C5.00714 11.4095 4.72947 11.294 4.49847 11.063C4.26747 10.8321 4.15197 10.5545 4.15197 10.23V9.81985H11.4085C11.7398 9.81985 12.0235 9.70185 12.2595 9.46585C12.4955 9.22985 12.6135 8.94613 12.6135 8.61468V3.99935H13.0238C13.3481 3.99935 13.6258 4.11485 13.8568 4.34585C14.0878 4.57685 14.2033 4.85452 14.2033 5.17885V12.3122C14.2033 12.4352 14.1622 12.536 14.0801 12.6147C13.9981 12.6933 13.9024 12.7327 13.793 12.7327ZM2.79297 8.43018L3.73664 7.48652H10.0751C10.1349 7.48652 10.184 7.46729 10.2225 7.42885C10.2609 7.3904 10.2801 7.34124 10.2801 7.28135V2.87118C10.2801 2.81129 10.2609 2.76213 10.2225 2.72368C10.184 2.68524 10.1349 2.66602 10.0751 2.66602H2.99814C2.93836 2.66602 2.88919 2.68524 2.85064 2.72368C2.81219 2.76213 2.79297 2.81129 2.79297 2.87118V8.43018ZM2.39347 10.0018C2.23847 10.0018 2.09964 9.94546 1.97697 9.83268C1.8543 9.71979 1.79297 9.57096 1.79297 9.38618V2.87118C1.79297 2.53974 1.91097 2.25602 2.14697 2.02002C2.38297 1.78402 2.66669 1.66602 2.99814 1.66602H10.0751C10.4065 1.66602 10.6901 1.78402 10.9261 2.02002C11.1621 2.25602 11.2801 2.53974 11.2801 2.87118V7.28135C11.2801 7.61279 11.1621 7.89651 10.9261 8.13251C10.6901 8.36852 10.4065 8.48652 10.0751 8.48652H4.15197L2.81747 9.82118C2.75502 9.88352 2.68814 9.92924 2.6168 9.95835C2.54536 9.98735 2.47091 10.0018 2.39347 10.0018Z"
        fill={color}
      />
    </svg>
  );
};

export default IconTalk;
